// shared/formly-fields/formly-field-primeng-multiselect.component.ts
import { Component } from '@angular/core';
import { FormControl } from '@angular/forms'; // Importa FormControl
import { FieldType } from '@ngx-formly/core'; // Importa FieldTypeConfig
import { isObservable, map, of } from 'rxjs'; // Per gestire le opzioni come Observable

@Component({
    selector: 'formly-field-primeng-multiselect', 
    styleUrls: ['../../config-page/config-page.component.scss'],
    template: `
   <div class="formly-primeng-multiselect mt20 mB10">
        <strong><label class="form-label">{{ to.label }}</label></strong>
        <br>
        <mat-form-field appearance="outline" class="w-full">
          <mat-select
            [formControl]="formControlTyped"
            [formlyAttributes]="field"
            [placeholder]="placeholder"
            multiple
            [disableOptionCentering]="true">
            <mat-option
              *ngFor="let option of (options$ | async) ?? []"
              [value]="option[to.optionValue || 'value']">
              {{ option[to.optionLabel || 'label'] }}
            </mat-option>
          </mat-select>
        </mat-form-field>
    </div>
    <p-divider></p-divider>`
})

export class FieldPrimengMultiselectComponent extends FieldType {

    get formControlTyped(): FormControl {
        return this.formControl as FormControl;
    }

    get options$() {
        const opts = this.to.options;
        return isObservable(opts)
            ? opts.pipe(map((options: any[] | null): any[] => options ? options : []))
            : of(opts ?? []);
    }

    get placeholder() {
        return this.to.placeholder ?? '';
    }

    get filter() {
        return this.to.filter ?? false;
    }

    get showClear() {
        return this.to.showClear ?? false;
    }
}